export default "__VITE_ASSET__0az2FQz7__"